import styles from "./Toast.styles.scss";

const Toast = ({message}) => {
  return <div className={styles.toast}>{message}</div>;
};

export default Toast;



// WEBPACK FOOTER //
// ./components/Toast/Toast.js